import { getMessageFromIframe, removeMessageFromIframe } from './infrastructure';
import { postGenericMessage } from './messages';
const MARGIN_TOP_BOTTOM_PX = 20;
function resizeIframeHeight(iframe, height, unit) {
    const iframeEl = document.querySelector(`#${iframe.id}`);
    // @ts-ignore: Comprends pas pourquoi cette erreur
    if (iframeEl)
        iframeEl.style.height = unit === '%' ? `${height}%` : `${height + MARGIN_TOP_BOTTOM_PX}px`;
}
function setIframeMinHeight(iframe, minHeightCalc) {
    const iframeEl = document.querySelector(`#${iframe.id}`);
    // @ts-ignore: Comprends pas pourquoi cette erreur
    if (iframeEl)
        iframeEl.style.minHeight = minHeightCalc;
}
function analyticsEvent(data, analyticService) {
    switch (data.analyticsFct) {
        case 'trackEvent':
            analyticService?.trackEvent(data.eventName, data.payload);
            break;
        case 'resetEcommerce':
            analyticService?.resetEcommerce();
            break;
        case 'flushStoredEvents':
            analyticService?.flushStoredEvents();
            break;
    }
}
export function microFrontListener({ iframe, callbackForMessages, router, analyticService }) {
    getMessageFromIframe(iframe.href, (data) => {
        if ('app' in data) {
            if ('minHeightCalc' in data.app)
                setIframeMinHeight(iframe, data.app.minHeightCalc);
            else
                resizeIframeHeight(iframe, data.app.height, data.app.unit);
        }
        if ('message' in data && callbackForMessages) {
            callbackForMessages(data);
        }
        if ('routing' in data && router) {
            if (data.routing.goBack) {
                if (router.options?.history?.state?.back) {
                    router.push({ path: router.options.history.state.back });
                }
                else
                    router.back();
            }
            else {
                try {
                    if (router.resolve(data.routing).name !== 'not-found')
                        router.push(data.routing);
                    else if (window.parent?.parentRouter)
                        window.parent?.parentRouter?.push(data.routing);
                }
                catch (error) {
                    if (window.parent?.parentRouter)
                        window.parent?.parentRouter?.push(data.routing);
                }
            }
        }
        if ('analyticsFct' in data && analyticService) {
            analyticsEvent(data, analyticService);
        }
    });
}
export function removeMicroFrontListener(iframeHref) {
    removeMessageFromIframe(iframeHref);
}
export function emitMessageToChild(microFrontName, { message, data = {} }) {
    postGenericMessage(microFrontName, { message, data });
}
//# sourceMappingURL=use-cases.js.map